import React from "react";

const STATUS_PILL_VARIANTS = {
    default: "status-pill status-pill-default",
    pending: "status-pill status-pill-pending",
    paid: "status-pill status-pill-paid",
    failed: "status-pill status-pill-failed",
    sent: "status-pill status-pill-sent",
    ready: "status-pill status-pill-ready",
    rectified: "status-pill status-pill-rectified",
    reversal: "status-pill status-pill-reversal",
    reversed: "status-pill status-pill-reversed",
};

const StatusPill = ({ label, variant = "default", className = "", children, ...rest }) => {
    const baseClass = STATUS_PILL_VARIANTS[variant] || STATUS_PILL_VARIANTS.default;
    const combinedClassName = className ? `${baseClass} ${className}` : baseClass;

    return (
        <span className={combinedClassName} {...rest}>
            {label || children}
        </span>
    );
};

export default StatusPill;

